import Component_Materials_9315435352de504603f1bdb717934874 from "../../../../content/examples/materials/Materials";
import Devtool_Materials_9315435352de504603f1bdb717934874 from "!!@devtool/loader!../../../../content/examples/materials/Materials";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_Materials_9315435352de504603f1bdb717934874,
  Devtool_Materials_9315435352de504603f1bdb717934874,
  DevTool,
  React
};